import { ArrowRight } from "lucide-react";
import { scrollToId } from "@/lib/scroll";
import { Reveal } from "@/components/Reveal";

export const FinalCTA = () => (
  <section className="bg-white py-16 sm:py-24 border-t border-line" data-testid="final-cta-section">
    <div className="max-w-[1280px] mx-auto px-4 sm:px-6 lg:px-8 text-center">
      <Reveal>
        <h2 className="font-display text-3xl sm:text-4xl lg:text-[2.8rem] font-semibold text-navy leading-tight">
          Ready to Find Your Next Property<span className="text-gold">?</span>
        </h2>
      </Reveal>
      <Reveal delay={0.1}>
        <p className="mt-4 text-sm sm:text-base lg:text-lg text-ink-soft">
          Let’s make your next property decision simpler.
        </p>
      </Reveal>
      <Reveal delay={0.2}>
        <div className="mt-9 flex flex-col sm:flex-row justify-center gap-3 sm:gap-4 max-w-md sm:max-w-none mx-auto">
          <button
            onClick={() => scrollToId("#properties")}
            data-testid="final-cta-explore-button"
            className="bg-gold text-navy hover:bg-gold-dark hover:-translate-y-0.5 transition-all duration-300 rounded-lg px-8 py-4 text-[15px] font-semibold inline-flex items-center justify-center gap-2 shadow-md shadow-gold/25"
          >
            Explore Properties <ArrowRight size={16} />
          </button>
          <button
            onClick={() => scrollToId("#contact")}
            data-testid="final-cta-contact-button"
            className="border border-gold text-navy hover:bg-gold/10 hover:-translate-y-0.5 transition-all duration-300 rounded-lg px-8 py-4 text-[15px] font-semibold"
          >
            Contact RK Real Estate
          </button>
        </div>
      </Reveal>
    </div>
  </section>
);
